export const environment = {
  production: true,
  apiUrl:
    "https://as-prod-smart-pd-integration-hpewddfpbxbbbyd4.westeurope-01.azurewebsites.net/api",
  msalConfig: {
    auth: {
      clientId: "98d3be92-6198-4a2f-9a6a-fa020120dc03",
      authority:
        "https://login.microsoftonline.com/76e3e3ff-fce0-45ec-a946-bc44d69a9b7e",
      redirectUri: "/",
    },
  },
  resourceConfig: [
    {
      scopes: ["user.read"],
      uri: "https://graph.microsoft.com/v1.0/me",
    },
    {
      scopes: ["api://SMART-PD-PROD/User.Read"],
      uri: "https://as-prod-smart-pd-integration-hpewddfpbxbbbyd4.westeurope-01.azurewebsites.net/api",
    },
  ],
};
